module.exports = __webpack_public_path__ + "static/media/loca.bf2417e2.ogg";